export const SILO_NODE_ABI = [
  {
    inputs: [
      { internalType: "string", name: "nodeId", type: "string" },
      { internalType: "uint16", name: "delegatorShareBps", type: "uint16" },
    ],
    name: "registerNode",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [{ internalType: "string", name: "nodeId", type: "string" }],
    name: "addProviderStake",
    outputs: [],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [
      { internalType: "string", name: "nodeId", type: "string" },
      { internalType: "uint256", name: "amount", type: "uint256" },
    ],
    name: "removeProviderStake",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [{ internalType: "string", name: "nodeId", type: "string" }],
    name: "delegate",
    outputs: [],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [
      { internalType: "string", name: "nodeId", type: "string" },
      { internalType: "uint256", name: "amount", type: "uint256" },
    ],
    name: "undelegate",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [{ internalType: "string", name: "nodeId", type: "string" }],
    name: "claimDelegatorReward",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [{ internalType: "string", name: "nodeId", type: "string" }],
    name: "claimProviderReward",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [{ internalType: "string", name: "nodeId", type: "string" }],
    name: "getNode",
    outputs: [
      {
        components: [
          { internalType: "bool", name: "registered", type: "bool" },
          { internalType: "address", name: "provider", type: "address" },
          { internalType: "uint16", name: "delegatorShareBps", type: "uint16" },
          { internalType: "uint256", name: "providerStake", type: "uint256" },
          { internalType: "uint256", name: "totalDelegated", type: "uint256" },
          { internalType: "bool", name: "exitRequested", type: "bool" },
          { internalType: "bool", name: "exitUnlocked", type: "bool" },
          { internalType: "uint256", name: "accRewardPerShare", type: "uint256" },
          { internalType: "uint256", name: "pendingProviderReward", type: "uint256" },
        ],
        internalType: "struct NodeStakingRewards.NodeData",
        name: "",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      { internalType: "string", name: "nodeId", type: "string" },
      { internalType: "address", name: "delegator", type: "address" },
    ],
    name: "getDelegation",
    outputs: [
      {
        components: [
          { internalType: "uint256", name: "amount", type: "uint256" },
          { internalType: "uint256", name: "rewardDebt", type: "uint256" },
          { internalType: "uint256", name: "pendingReward", type: "uint256" },
        ],
        internalType: "struct NodeStakingRewards.DelegationData",
        name: "",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [{ internalType: "string", name: "nodeId", type: "string" }],
    name: "getActiveDelegatorCount",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getTotalActiveDelegators",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      { internalType: "string", name: "nodeId", type: "string" },
      { internalType: "address", name: "delegator", type: "address" },
    ],
    name: "estimateDelegatorEarningLRS",
    outputs: [{ internalType: "uint256", name: "estimatedLRS", type: "uint256" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      { internalType: "address", name: "delegator", type: "address" },
      { internalType: "uint256", name: "offset", type: "uint256" },
      { internalType: "uint256", name: "limit", type: "uint256" },
    ],
    name: "getDelegatedNodeDetails",
    outputs: [
      {
        components: [
          { internalType: "string", name: "nodeId", type: "string" },
          { internalType: "address", name: "provider", type: "address" },
          { internalType: "uint16", name: "delegatorShareBps", type: "uint16" },
          { internalType: "uint256", name: "delegatedAmount", type: "uint256" },
          { internalType: "uint256", name: "pendingReward", type: "uint256" },
          { internalType: "uint256", name: "totalNodeDelegation", type: "uint256" },
          { internalType: "uint256", name: "averageDelegatorRewardPerEpoch", type: "uint256" },
          { internalType: "uint256", name: "estimatedNextEpochEarningLRS", type: "uint256" },
        ],
        internalType: "struct NodeStakingRewards.DelegatedNodeDetails[]",
        name: "details",
        type: "tuple[]",
      },
      { internalType: "uint256", name: "total", type: "uint256" },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      { internalType: "string", name: "nodeId", type: "string" },
      { internalType: "address", name: "delegator", type: "address" },
    ],
    name: "getDelegatorNodeStats",
    outputs: [
      {
        components: [
          { internalType: "uint256", name: "totalDelegated", type: "uint256" },
          { internalType: "uint256", name: "totalUndelegated", type: "uint256" },
          { internalType: "uint256", name: "totalClaimedRewards", type: "uint256" },
          { internalType: "uint256", name: "lastActionAt", type: "uint256" },
          { internalType: "uint256", name: "lastClaimAt", type: "uint256" },
        ],
        internalType: "struct NodeStakingRewards.DelegatorNodeStats",
        name: "",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [{ internalType: "string", name: "nodeId", type: "string" }],
    name: "getNodeRewardStats",
    outputs: [
      {
        components: [
          { internalType: "uint256", name: "totalSubmittedRewards", type: "uint256" },
          { internalType: "uint256", name: "totalProviderRewards", type: "uint256" },
          { internalType: "uint256", name: "totalDelegatorRewards", type: "uint256" },
          { internalType: "uint256", name: "rewardSubmissionCount", type: "uint256" },
          { internalType: "uint256", name: "lastSubmittedAt", type: "uint256" },
          { internalType: "uint256", name: "lastSubmittedReward", type: "uint256" },
          { internalType: "uint256", name: "totalProviderClaimed", type: "uint256" },
        ],
        internalType: "struct NodeStakingRewards.NodeRewardStats",
        name: "",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      { internalType: "string", name: "nodeId", type: "string" },
      { internalType: "address", name: "delegator", type: "address" },
    ],
    name: "pendingDelegatorReward",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [{ internalType: "string", name: "nodeId", type: "string" }],
    name: "pendingProviderReward",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "totalProviderPrincipal",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "totalDelegatorPrincipal",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "totalNodes",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "totalPendingProviderRewards",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "totalPendingDelegatorRewards",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "totalLiabilities",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "freshUndistributedRewards",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "minProviderStake",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "minDelegation",
    outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
    stateMutability: "view",
    type: "function",
  },
] as const;

export const SILO_NODE_CONTRACT = (import.meta.env.VITE_SILO_NODE_CONTRACT_ADDRESS || "") as `0x${string}`;
